import { createSlice } from '@reduxjs/toolkit';
import { addExtraReducer } from '../../utils/addExtraReducer';
import initialState from './initialState';
import { GetOnlineUsers } from './thunks';
import { GetOnlineUsersReducer, ResetOnlineUsersStateReducer } from './reducers';

// ----------------------------------------------------------------------------

export const slice = createSlice({
  name: 'onlineUsers',
  initialState,
  reducers: {
    ResetOnlineUsersState: ResetOnlineUsersStateReducer,
  },
  extraReducers: (builder) => {
    addExtraReducer(builder, GetOnlineUsers, GetOnlineUsersReducer);
  },
});

export default slice.reducer;
